import type { Experiment } from '@/types/aggregation/home';

export const AMPLITUDE_EXPERIMENTS = {
    ENABLE_GAME_LAUNCH_MOBILE_WEB: 'enable-game-launch-mobile-web',
    SWJ_TICKER_REDESIGN: 'casino-jackpots-ticker-pill',
    REMIND_ME_WEB: 'remind-me-web',
    /** Mobile web only: lobby builds launcher URLs on same host under `/game-play`. */
    SAME_DOMAIN_LAUNCH: 'same_domain_launch',
    SWJ_INTERSTITIAL_V2: 'swj-interstitial-v2',
    SIMILAR_GAMES: 'similar-games-web',
    TOP_NAV_RANKING: 'top-nav-ranking',
    SEARCH_ML: 'search-ml',
    HAS_CASINO_SEARCH_SERVICE: 'has_casino_search_service',
    GIP_VIDEOS_WEB: 'gip-videos-web',
    /** Redirect between launcher and gw domains based on useGameWindow cookie. */
    GAME_WINDOW_V3: 'game-window-v3',
    /** Refer-a-Friend redesign on the `/refer` route. */
    RAF_REDESIGN_V2: 'raf-redesign-v2',
    /** entry point for influencer hub & gameplay session (exposure fired for both arms). */
    INFLUENCER_VIDEO_LIBRARY_PAGE: 'peaky-influencer-video-library-page',
    /** Top picks for you: control (DynamoDB) vs variant (Valkey). Exposure on zone render. */
    TPFY_V2: 'tpfy-v2',
    ROTATING_ZONE_TITLE: 'rotating-zone-titles',
    HOT_RIGHT_NOW_ZONE: 'hot-right-now-zone-experiment',
    HAS_SPLASH_TOOL: 'has_splash_tool'
} as const;

export const ROTATING_ZONE_TITLE_VARIANT = {
    CONTROL: 'control',
    TIMED: 'time-based',
    LAUNCH: 'refresh-based'
} as const;

export const ANDROID_NATIVE_EXPERIMENTS = {
    /** When enabled, native Android handles reality check and web UM must not start it. */
    NATIVE_REALITY_CHECK: 'native-reality-check-casino-android'
} as const;

export const getExperimentValue = (experiments: Experiment, experimentKey: string): string | undefined => {
    return experiments?.[experimentKey]?.value;
};

export const isExperimentEnabled = (experiments: Experiment, experimentKey: string): boolean => {
    return getExperimentValue(experiments, experimentKey) === 'on';
};

/** Amplitude feature flags use `key: "on"` when enabled (distinct from experiment variants). */
export const isExperimentKeyOn = (experiments: Experiment, experimentKey: string): boolean => {
    return experiments?.[experimentKey]?.key === 'on';
};
